import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';

export const spinnerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    const spinnerService = inject(SpinnerService);

    // Show the spinner when the HTTP request is made
    spinnerService.show();

    return next(req).pipe(
        finalize(() => {
            spinnerService.hide();
        }),
        catchError((error) => {
            spinnerService.hide();
            throw error;
        })
    );
};